export const CALENDAR_HASH = "calendarHash";
export const FOCUSED_EVENT_ID = "focusedEventId";
export const DATE_HASH_REGEX = /(day|week)(\/(\d{4}))(\/(0[1-9]|10|11|12))(\/(0[1-9]|[12]\d|3[01]))$/; // [day|week]/YYYY/MM/DD
